import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import HeaderHV from "./components/HeaderHV/HeaderHV";
import HomeHV from "./pages/home/HomeHV";
import ClinicWeeklySchedule from "./components/ClinicWeeklySchedule/ClinicWeeklySchedule";
import ClinicWeeklyScheduleTV from "./components/ClinicWeeklySchedule/ClinicWeeklyScheduleTV";
import ClinicWeeklySchedule7Days from "./components/ClinicWeeklySchedule/ClinicWeeklySchedule7Days/ClinicWeeklySchedule7Days";
import LiberationDay from "./pages/liberation/LiberationDay";
import NationalDay from "./pages/national-day/NationalDay";
import PatientSafetyDay from "./pages/patient-safety/PatientSafetyDay";
import DigitalTransformationDay from "./pages/digital-transformation/DigitalTransformationDay";

export default function App() {
  const { pathname } = useLocation();

  // ẨN HEADER Ở TRANG TV + TRANG 7 NGÀY + TRANG KỶ NIỆM 30/4 + 2/9 + 17/9 + 10/10
  const showHeader =
    pathname !== "/lich-kham-tv" &&
    pathname !== "/lich-phong-kham-7-ngay" &&
    pathname !== "/ngay-giai-phong" &&
    pathname !== "/quoc-khanh" &&
    pathname !== "/an-toan-nguoi-benh" &&
    pathname !== "/chuyen-doi-so";

  return (
    <>
      {showHeader && <HeaderHV />}
      {showHeader && <div className="hv-spacer" />}

      <Routes>
        <Route path="/" element={<HomeHV />} />
        <Route path="/lich-kham" element={<ClinicWeeklySchedule />} />
        <Route path="/lich-kham-tv" element={<ClinicWeeklyScheduleTV />} />
        <Route
          path="/lich-phong-kham-7-ngay"
          element={<ClinicWeeklySchedule7Days />}
        />
        <Route path="/ngay-giai-phong" element={<LiberationDay />} />
        <Route path="/quoc-khanh" element={<NationalDay />} />
        <Route path="/an-toan-nguoi-benh" element={<PatientSafetyDay />} />
        <Route path="/chuyen-doi-so" element={<DigitalTransformationDay />} />
      </Routes>
    </>
  );
}
